
import type { VoidFunctionComponent } from 'react';

import useGetReleaseGroupDependency, {
  getReleaseGroupDependencyQueryKey,
} from '../../../../hooks/api/dependencies/useGetReleaseGroupDependency';
import queryClient from '../../../../ReactQuery/client';

import DependencyDrawer from './DependencyDrawer';
import type { DrawerReleaseGroupScope } from './types';

type Props = {
  onClose: () => void;
  releaseGroupId: number;
  releaseGroupReleaseId: number;
  dependencyRevisionLocator: string;
  scope: DrawerReleaseGroupScope;
  /**
   * A callback that's performed when a dependency is ignored or deleted.
   */
  onDeleteDependency?: () => void;
  /**
   * A callback that's performed when a dependency is edited.
   */
  onEditDependency?: () => void;
};

const ReleaseGroupDependencyDrawer: VoidFunctionComponent<Props> = ({
  onClose,
  releaseGroupId,
  releaseGroupReleaseId,
  dependencyRevisionLocator,
  scope,
  onDeleteDependency,
  onEditDependency,
}) => {
  const { data, isLoading } = useGetReleaseGroupDependency(
    releaseGroupId,
    releaseGroupReleaseId,
    dependencyRevisionLocator,
  );

  return (
    <DependencyDrawer
      onClose={onClose}
      dependency={data?.dependency ?? null}
      isLoading={isLoading}
      onEditDependency={() => {
        queryClient.invalidateQueries({
          queryKey: getReleaseGroupDependencyQueryKey(releaseGroupId, releaseGroupReleaseId, dependencyRevisionLocator),
        });
        onEditDependency?.();
      }}
      onDeleteDependency={onDeleteDependency}
      scope={scope}
    />
  );
};

export default ReleaseGroupDependencyDrawer;
